<template>
	<div class="container">
		<div class="page">
			<!-- Header -->
			<div class="page-header">
				<div class="row">
					<div class="col-md-9">
						<h1 class="page-title">{{ $t('OStock Brand') }}</h1>
					</div>
				</div>
			</div>

			<!-- Table Menu -->
			<div class="table-list-menu d-lg-flex align-items-center">
				<div class="table-actions d-flex align-items-center flex-wrap">
					<!-- Add Brand -->
					<a href="/brand" class="btn btn-primary btn-sm flex-center mr-2">
						<i class="material-icons">add</i>
						<span>{{ $t('Request Produk') }}</span>
					</a>
				</div>

				<div class="table-filters text-right d-flex align-items-center ml-a">
					<!-- Clear Filter -->
					<button type="button" class="btn btn-plain btn-sm" @click="clearFilter" v-if="isFilterOn">
						{{ $t('Clear Filter') }}
					</button>
					<!-- Date Filter -->
					<daterangepicker :presets="filterDatePresets" :start="since" :end="until" @selected="setFilterDate">
					</daterangepicker>
				</div>
			</div>

			<!-- Main Table -->
			<div class="products-list table-responsive" v-if="isRouteChecked">
				<table class="products-list-table table table-primary table-striped mb-0">
					<thead>
						<tr>
							<th width="5%">No.</th>
							<th class="text-left">
								{{ $t('Jenis Produk') }}
							</th>
							<th class="text-left">
								{{ $t('Foto Produk') }}
							</th>
							<th class="text-left">
								{{ $t('Link Produk') }}
							</th>
							<th class="text-left">
								{{ $t('Deskripsi Produk') }}
							</th>
							<th class="text-left">
								{{ $t('Source') }}
							</th>
							<th class="text-left">
								{{ $t('Tanggal') }}
							</th>
							<th class="text-left">
								{{ $t('Status') }}
							</th>
							<th class="text-center">
								{{ $t('Action') }}
							</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(brand, idx) in brands" :key="brand._id.$oid">
							<!-- No. -->
							<td class="text-center">{{ idx + 1 }}.</td>
							<!-- Brand Category -->
							<td class="mw-150">
								<div>{{ formatCategory(brand.category) }}</div>
							</td>
							<!-- Brand Images -->
							<td>
								<div class="row cursor-pointer mw-250" @click="editBrand(brand)">
									<div class="col px-1"
										v-for="(image, index) in brand.product_images.slice(0, maxImageShown + 1)"
										:key="index + 0">
										<div v-if="image === ''" class="pc-image-empty square-img"
											@click="uploadImages(index)">
											<div class="image-upload-placeholder placeholder-height">
												<i class="fi fi-rr-picture image-placeholder fs-16"
													v-if="index < maxImageShown"></i>
												<div class="text-placeholder pt-0 fs-12">
													<span v-if="index < maxImageShown">
														Foto {{ index + 1 }}
													</span>
													<span v-else>
														2+
													</span>
												</div>
											</div>
										</div>
										<div v-else class="pc-image square-img">
											<div class="img" :style="{ backgroundImage: `url('${image}')` }">
											</div>
										</div>
									</div>
								</div>
							</td>
							<!-- Reference Link -->
							<td>
								<div>
									<a :href="brand.reference_link" target="_blank" v-if="brand.reference_link">{{ brand.reference_link }}</a>
									<span v-else>-</span>
								</div>
							</td>
							<!-- Description -->
							<td class="mw-150">
								<div>{{ formatDescription(brand) }}</div>
							</td>
							<!-- Source -->
							<td class="mw-150">
								<div>{{ formatSource(brand) }}</div>
							</td>
							<!-- Date -->
							<td class="mw-150">
								<div>{{ formatDate(brand.created_at) }}</div>
							</td>
							<!-- Status -->
							<td>
								<div :class="`text-${formatStatus(brand.status).color}`">{{ formatStatus(brand.status).label
								}}</div>
							</td>
							<!-- Action -->
							<td class="text-center">
								<i class="fas fa-edit cursor-pointer" @click="editBrand(brand)"></i>
							</td>
						</tr>
					</tbody>
				</table>
				<div class="list-empty table-empty" v-if="brands.length === 0 && isFetching === false">
					<i class="material-icons mr-2 va-m">error_outline</i>
					<span class="va-m" v-if="keyword === ''">{{ $t("You haven't created any brands yet") }}.</span>
					<span class="va-m" v-else>{{ $t('No brands was found') }}</span>
				</div>
			</div>

			<!-- Table Loader -->
			<div class="table-fetch-status" v-if="isFetching">
				<div class="is-loading large dark m-auto"></div>
			</div>
		</div>

		<!-- Modals -->
		<div class="modals">

			<!-- Modal Edit -->
			<modal class="table-filter-modal" size="medium" @close="isShowEdit = false" v-if="isShowEdit">
				<div slot="header">
					<h3>Edit Brand</h3>
				</div>
				<div slot="body">

					<!-- Categories -->
					<div class="col-md-12">
						<div class="form-group">
							<label>Jenis Produk Yang Diminati <span class="text-danger">*</span></label>
							<div class="mb-2">
								<multiselect placeholder="Select Category" label="name" track-by="slug"
									@close="categoryValidation" @select="onCategoryChange"
									v-model="selectedCategory" :options="categories"
									:show-labels="false" :allow-empty="false"
									:disabled="categories.length === 0">
								</multiselect>
								<small v-if="errorMessages.category" class="text-danger">{{ errorMessages.category }}</small>
							</div>

							<div>
								<multiselect v-if="subCategories" placeholder="Select Sub Category" label="name" track-by="slug"
									v-model="selectedSubCategory" :options="subCategories" :show-labels="false"
									:allow-empty="false"
									:disabled="subCategories.length === 0">
								</multiselect>
								<small v-if="errorMessages.subCategory" class="text-danger">{{ errorMessages.subCategory }}</small>
							</div>
						</div>
					</div>

					<div class="col-md-12">
						<div class="form-group">
							<label>Deskripsi Produk (Spesifikasi Produk) <span class="text-danger">*</span></label>
							<textarea class="form-control"
								:class="{ 'is-invalid': errorMessages.description }"
								placeholder="Masukkan Deskripsi Produk..." rows="3"
								required
								v-model="description"></textarea>
							<small v-if="errorMessages.description" class="invalid-feedback">{{ errorMessages.description }}</small>
						</div>
					</div>

					<div class="row mx-0 w-100">
						<div class="col-md-12">
							<label>Contoh Foto Produk</label>
							<p class="pc-p">
								Format gambar .jpg .jpeg .png dan ukuran minimum 300 x 300px (Untuk gambar
								optimal gunakan ukuran minimum 700 x 700 px). Ukuran maksimum gambar adalah <b>2MB</b>.
							</p>
							<small v-if="errorMessages.image" class="text-danger">{{ errorMessages.image }}</small>
						</div>
						<div class="col-md-12">
							<div class="box__content">
								<div class="pc-images-list">
									<draggable draggable=".draggable" v-model="product.images" v-bind="dragOptions"
										@start="drag = true" @end="drag = false">
										<transition-group class="row small-gutter" type="transition"
											:name="!drag ? 'flip-list' : null">
											<div class="col" :class="{ draggable: image !== '' }"
												v-for="(image, index) in product.images" :key="index + 0">
												<div v-if="isLoading && image === ''" class="pc-image-empty">
													<div class="image-loading">
														<div class="is-loading"></div>
													</div>
												</div>
												<div v-else-if="image === ''" class="pc-image-empty cursor-pointer"
													@click="uploadImages(index)">
													<div class="image-upload-placeholder">
														<i class="fi fi-rr-picture image-placeholder"></i>
														<div class="text-placeholder">
															Foto {{ index + 1 }}
														</div>
													</div>
												</div>
												<div v-else class="pc-image" :class="{
													'is-loading': image === '',
												}">
													<div class="img" :style="{ backgroundImage: `url('${image}')` }">
													</div>
													<i class="material-icons" v-tooltip="'Remove'"
														@click="removeProductImages(index)">close</i>
												</div>
											</div>
										</transition-group>
									</draggable>
								</div>
								<div class="form-group buttons m-0 hidden">
									<input type="file" accept="image/*" class="input-file" ref="imageUploader"
										id="pc-product-images-file" @change="onProductImagesChange" />
								</div>
							</div>
						</div>
					</div>

					<div class="col-md-12">
						<div class="form-group">
							<label>Link Referensi Produk</label>
							<input type="text" class="form-control"
								placeholder="https://"
								v-model.trim="referenceLink">
							<small v-if="errorMessages.referenceLink" class="text-danger">{{ errorMessages.referenceLink
							}}</small>
						</div>
					</div>

					<div class="col-md-12">
						<div class="form-group">
							<label>Dari mana Anda mengetahui tentang Ostock <span class="text-danger">*</span></label>
							<select v-model="selectedSource" @change="sourceValidation" class="form-control">
								<option value="" disabled selected>Pilih Sumber</option>
								<option :value="source.value" v-for="source in sourceOptions"
									:key="source.value">{{ source.label }}</option>
							</select>
							<small v-if="errorMessages.selectedSource" class="text-danger">{{ errorMessages.selectedSource }}</small>
						</div>
					</div>

					<div class="col-md-12" v-if="isOtherSource">
						<div class="form-group">
							<label>Masukkan Sumber Lainnya <span class="text-danger">*</span></label>
							<input type="text" class="form-control"
								placeholder="Masukkan Sumber Lainnya"
								@keyup="sourceValueValidation"
								v-model.trim="sourceValue">
							<small v-if="errorMessages.sourceValue" class="text-danger">{{ errorMessages.sourceValue }}</small>
						</div>
					</div>
				</div>
				<div slot="footer">
					<button type="button" class="btn btn-light" @click="isShowEdit = false">
						{{ $t('Close') }}
					</button>
					<button type="button" class="btn btn-primary" :class="{ 'is-loading': isUpdateBrand }"
						@click="updateBrand">
						Update
					</button>
				</div>
			</modal>

		</div>

		<notifications group="products" position="bottom right" />
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import draggable from 'vuedraggable';
import Modal from '@/components/Modal.vue';
import Daterangepicker from '@/components/Daterangepicker.vue';
import brandApi from '@/api/brand';
import homepageApi from '@/api/homepage';
import mediaApi from '@/api/media';
import { statusOptions, sourceOptions } from '@/lib/statics';
import {
	getDateRange,
	duplicateVar,
	getAxiosErrorMessage,
	isUrlValid,
} from '@/lib/helper';

const defaultFilterDate = getDateRange();

export default {
	name: 'brands',
	components: {
		Modal,
		Daterangepicker,
		draggable,
	},
	data() {
		return {
			limit: 25,
			sort_by: 'created_at',
			sort: 'desc',
			filterDate: defaultFilterDate,
			isUpdateBrand: false,
			statusOptions,
			selectedBrand: null,
			isShowEdit: false,
			isFetchingCategories: false,
			categories: [],
			subCategories: [],
			selectedCategory: null,
			selectedSubCategory: null,
			description: '',
			isLoading: false, // is uploading images
			drag: false,
			dragOptions: {
				animation: 100,
			},
			product: {
				images: ['', '', '', '', ''],
			},
			productImages: [],
			productImagesLimit: 5,
			referenceLink: '',
			sourceOptions,
			selectedSource: '',
			sourceValue: '',
			errorMessages: {
				// name: '',
				// storeName: '',
				// email: '',
				// phone: '',
				subdistrict: '',
				address: '',
				category: '',
				subCategory: '',
				description: '',
				image: '',
				referenceLink: '',
				selectedSource: '',
				sourceValue: '',
			},
			maxImageShown: 3,
		};
	},
	methods: {
		...mapActions({
			getBrands: 'brand/getBrands',
			resetBrands: 'brand/resetBrands',
		}),
		getParams() {
			const dateFormat = 'YYYY-MM-DD';
			const startDate = this.moment(this.filterDate.start).format(dateFormat);
			const endDate = this.moment(this.filterDate.end).format(dateFormat);

			const params = {
				limit: this.limit,
				sort_by: this.sort_by,
				sort: this.sort,
				page: this.page,
				since: startDate,
				until: endDate,
			};

			return params;
		},
		fetchBrands(reset = true) {
			if (reset) {
				this.resetBrands();
			}
			const params = this.getParams();
			this.getBrands(params);
		},
		checkCapabilities() {
			this.isRouteChecked = true;
		},
		initFilterDate() {
			if (this.since && this.since !== '' && this.until && this.until !== '') {
				const since = this.moment(this.since);
				const until = this.moment(this.until);
				const filterDate = {
					start: since,
					end: until,
				};
				this.filterDate = filterDate;
			}
		},
		setFilterDate(filterDate) {
			this.filterDate = filterDate;
			const format = 'YYYY-MM-DD';
			const since = this.moment(filterDate.start).format(format);
			const until = this.moment(filterDate.end).format(format);
			const query = duplicateVar(this.$route.query);
			query.since = since;
			query.until = until;
			const params = { query };
			this.$router.push(params);
			this.fetchBrands();
		},
		clearFilter() {
			window.location.href = '/brand/list';
		},
		formatDescription(brand) {
			return brand.description || '-';
		},
		formatSource(brand) {
			const empty = '-';
			const sourceKey = brand.source ? brand.source.key : '';
			if (!sourceKey) {
				return empty;
			}
			const selectedSource = this.sourceOptions.find(source => source.value === sourceKey);
			if (!selectedSource) {
				return empty;
			}
			let sourceLabel = selectedSource.label;
			if (sourceKey === 'others') {
				sourceLabel = `Lainnya : ${brand.source.value}`;
			}
			return sourceLabel;
		},
		formatCategory(category) {
			let categoryString = category.name;
			categoryString += category.sub_category ? ` - ${category.sub_category.name}` : '';
			return categoryString;
		},
		formatDate(dateString) {
			const dateNumberLong = date => new Date(parseInt(date.$date.$numberLong));
			const date = typeof dateString === 'object' ? dateNumberLong(dateString) : dateString;
			const timezone = this.user ? this.user.timezone : 'Asia/Jakarta';
			const formattedDate = this.moment
				.utc(date)
				.tz(timezone)
				.format('DD MMM YYYY');
			return dateString && dateString !== '' ? formattedDate : '-';
		},
		formatStatus(statusValue) {
			const selectedStatus = this.statusOptions.find(status => status.value === statusValue);
			return {
				label: selectedStatus?.label,
				color: selectedStatus?.color,
			};
		},
		categoryValidation() {
			if (this.selectedCategory
				&& this.selectedCategory.slug !== 'uncategorized'
				&& this.selectedCategory.slug !== 'produk-lainnya') {
				this.errorMessages.category = '';
			} else {
				this.errorMessages.category = 'Kategori Wajib Dipilih';
			}
		},
		subCategoryValidation() {
			if (this.selectedSubCategory) {
				this.errorMessages.subCategory = '';
			} else {
				this.errorMessages.subCategory = 'Sub Kategori Wajib Dipilih';
			}
		},
		descriptionValidation() {
			if (this.description.length <= 0) {
				this.errorMessages.description = 'Deskripsi Wajib Diisi';
			} else {
				this.errorMessages.description = '';
			}
		},
		fetchCategories() {
			this.isFetchingCategories = true;
			const callback = (response) => {
				this.isFetchingCategories = false;
				const categories = response.data;
				this.categories = categories;
			};
			const errorCallback = () => {
				this.isFetchingCategories = false;
			};
			homepageApi.getAllCategories(callback, errorCallback);
		},
		onCategoryChange(category) {
			this.selectedSubCategory = null;
			this.subCategories = category?.sub_categories;
		},
		uploadImages(index) {
			this.currentIndexUploadImage = index;
			const inputFile = this.$refs.imageUploader;
			inputFile.click();
		},
		onProductImagesChange(event) {
			this.isLoading = true;
			const maxUploadSize = 2; // MB
			const input = event.target;
			for (let i = 0; i < input.files.length; i++) {
				const image = input.files[i];

				// Check File Size
				let fileSize = image.size;
				fileSize /= 1048576;

				// Limit Images
				const isLimitReached =
					this.productImages.length === this.productImagesLimit;
				const isFileSizeTooLarge = fileSize > maxUploadSize;

				// Show Notice if size too large
				if (isFileSizeTooLarge) {
					const noticeMessage = `'${image.name}' size is too large (max 2MB)`;
					this.$notify({
						group: 'app',
						text: noticeMessage,
						type: 'warn',
					});
					this.isLoading = false;
					break;
				}

				if (isLimitReached) {
					const noticeMessage = 'Maksimum upload 5 foto produk';
					this.$notify({
						group: 'app',
						text: noticeMessage,
						type: 'warn',
					});
					this.isLoading = false;
					break;
				}

				this.productImages.push(image);

				const previewIndex = this.currentIndexUploadImage;

				this.$set(this.product.images, previewIndex, '');

				// Load the image file into a canvas element
				const img = new Image();
				const canvas = document.createElement('canvas');
				const ctx = canvas.getContext('2d');
				const reader = new FileReader();
				// eslint-disable-next-line no-loop-func
				reader.onload = () => {
					img.onload = () => {
						const size = Math.max(img.width, img.height);
						canvas.width = size;
						canvas.height = size;
						const offsetX = (size - img.width) / 2;
						const offsetY = (size - img.height) / 2;
						ctx.fillStyle = '#fff';
						ctx.fillRect(0, 0, size, size); // fill the canvas with white
						ctx.drawImage(img, offsetX, offsetY);

						// Convert the canvas to a blob and upload it to the server
						canvas.toBlob((blob) => {
							// Start Upload
							const uploadParams = new FormData();
							uploadParams.append('image', blob);

							const callback = (response) => {
								this.isLoading = false;
								const path = response.data;
								const url = `${this.mediaUrlPrefix}/${path}`;
								this.$set(this.product.images, previewIndex, url);
								this.linkImageValidation();
							};

							const errorCallback = () => {
								this.isLoading = false;
								// eslint-disable-next-line
								this.productImages.splice(previewIndex, 1);
								this.product.images.splice(previewIndex, 1);
								this.linkImageValidation();
							};

							// Upload Image
							mediaApi.uploadImagePublic(uploadParams, callback, errorCallback);
						}, image.type, 0.9);
					};
					img.src = reader.result;
				};
				reader.readAsDataURL(image);
			}
			event.target.files = null;
			event.target.value = '';
		},
		removeProductImages(index) {
			this.productImages.splice(index, 1);
			this.product.images.splice(index, 1, '');
		},
		linkImageValidation() {
			const image = this.product.images.find(img => img !== '');
			if (!image && !this.referenceLink) {
				this.errorMessages.image = 'Upload minimal 1 gambar atau isi Link Referensi';
				this.errorMessages.referenceLink = 'Isi Link Referensi atau Upload minimal 1 gambar';
			} else if (this.referenceLink && !isUrlValid(this.referenceLink)) {
				this.errorMessages.referenceLink = 'Link harus valid dan diawali https:// atau http://';
			} else {
				this.errorMessages.image = '';
				this.errorMessages.referenceLink = '';
			}
		},
		sourceValidation() {
			if (this.selectedSource === '') {
				this.errorMessages.selectedSource = 'Source Wajib Dipilih';
			} else {
				this.errorMessages.selectedSource = '';
			}
		},
		sourceValueValidation() {
			if (this.selectedSource === 'others' && this.sourceValue === '') {
				this.errorMessages.sourceValue = 'Source Wajib Diisi';
			} else {
				this.errorMessages.sourceValue = '';
			}
		},
		validateAllForm() {
			this.categoryValidation();
			// this.subCategoryValidation();
			this.descriptionValidation();
			this.linkImageValidation();
			this.sourceValidation();
			this.sourceValueValidation();
		},
		assignCategory(selectedBrand) {
			this.selectedCategory = selectedBrand.category;
			const categories = this.categories.find(category => category.slug === this.selectedCategory.slug);
			this.onCategoryChange(categories);
			const category = selectedBrand.category;
			const subCategory = category.sub_category ? category.sub_category : null;
			this.selectedSubCategory = subCategory;
		},
		assignSource(selectedBrand) {
			const source = selectedBrand.source || null;
			this.selectedSource = source ? source.key : '';
			this.sourceValue = this.isOtherSource ? source.value : '';
		},
		editBrand(brand) {
			this.selectedBrand = brand;
			this.assignCategory(this.selectedBrand);
			this.description = this.selectedBrand.description || '';
			this.product.images = this.selectedBrand.product_images;
			this.referenceLink = this.selectedBrand.reference_link;
			this.assignSource(this.selectedBrand);
			this.isShowEdit = true;
		},
		getCategoryParams() {
			const selectedSubCategory = duplicateVar(this.selectedSubCategory);
			const selectedCategory = duplicateVar(this.selectedCategory);
			delete selectedSubCategory.sub_sub_categories;
			delete selectedCategory.sub_categories;
			delete selectedCategory._id;
			delete selectedSubCategory._id;
			delete selectedSubCategory.parent_id;

			const category = {
				...selectedCategory,
				sub_category: selectedSubCategory,
			};

			return category;
		},
		getSourceParams() {
			const source = {
				key: this.selectedSource,
				value: this.isOtherSource ? this.sourceValue : this.selectedSource,
			};

			return source;
		},
		updateBrand() {
			this.validateAllForm();
			const isErrorExist = Object.values(this.errorMessages).find(val => val !== '');
			if (isErrorExist) {
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Failed',
					text: 'Form harus diisi.',
				});
				return;
			}

			this.isUpdateBrand = true;

			const category = this.getCategoryParams();
			const source = this.getSourceParams();

			const params = {
				...this.selectedBrand,
				category,
				description: this.description,
				product_images: this.product.images,
				reference_link: this.referenceLink,
				source,
			};

			const callback = (response) => {
				const message = response.message;
				this.$notify({
					group: 'app',
					title: 'Update Brand',
					text: message,
					type: 'success',
				});
				this.isUpdateBrand = false;
				this.isShowEdit = false;
				this.fetchBrands();
			};

			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					title: 'Save Brand',
					text: message,
					type: 'error',
				});
				this.isUpdateBrand = false;
			};

			brandApi.updateBrand(this.selectedBrand._id.$oid, params, callback, errorCallback);
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			brands: 'brand/allBrands',
			isFetching: 'brand/isFetching',
			isAll: 'brand/isAll',
			page: 'brand/page',
			isFetched: 'brand/isFetched',
			filterDatePresets: 'filterDatePresets',
		}),
		since() {
			const since = this.$route.query.since;
			return since;
		},
		until() {
			const until = this.$route.query.until;
			return until;
		},
		isFilterOn() {
			return (
				this.since
				|| this.until
			);
		},
		isOtherSource() {
			return this.selectedSource === 'others';
		},
	},
	watch: {
		user() {
			this.initFilterDate();
			this.checkCapabilities();
		},
		'$route.query': {
			immediate: true,
			handler() {
				this.fetchBrands();
			},
		},
	},
	created() {
		if (this.user) {
			this.initFilterDate();
			this.checkCapabilities();
		}
		// Fetch Brands
		this.fetchBrands();
		// Fetch Categories
		this.fetchCategories();
		// On Scroll Bottom
		window.addEventListener('scroll', this.handleScroll);
	},
	destroyed() {
		window.removeEventListener('scroll', this.handleScroll);
	},
};
</script>

<style scoped>
.square-img {
	max-width: 60px;
	max-height: 60px;
}

.mw-150 {
	min-width: 150px;
}

.mw-250 {
	min-width: 250px;
}

.fs-16 {
	font-size: 16px !important;
}

.fs-12 {
	font-size: 12px !important;
}

.placeholder-height {
	height: 60px;
}
</style>
